import { render, staticRenderFns } from "./SaveReportWizardPreview.vue?vue&type=template&id=135ef930"
import script from "./SaveReportWizardPreview.vue?vue&type=script&lang=js"
export * from "./SaveReportWizardPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports